import * as React from 'react';
import MUITabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import cn from 'classnames';

import { useTheme } from '../theme';

export interface TabElement {
	header: string;
	label?: React.ReactNode;
	disabled?: boolean;
	value: number;
}

interface Props {
	tabs: TabElement[];
	onChange: (value: number) => void;
	selected: number;
	tabsAlign?: 'left' | 'center' | 'right';
	className?: string;
	tabClassName?: string;
	selectedTabClassName?: string;
	indicatorClassName?: string;
	tabHeaderClassName?: string;
	tabLabelClassName?: string;
	flexContainerClassName?: string;
	variant?: 'scrollable' | 'standard' | 'fullWidth';
	tabsWrp?: React.Ref<HTMLDivElement>;
	scrollButtons?: boolean | 'auto';
	style?: 'rounded' | 'normal';
	rootTabsClassName?: string;
}

const Tabs: React.FunctionComponent<Props> = props => {
	const { Tabs: theme } = useTheme('Tabs');

	return (
		<div
			ref={props.tabsWrp}
			className={cn(theme.container, props.className, { [theme.container_rounded]: props.style === 'rounded' })}
		>
			<MUITabs
				scrollButtons={props.scrollButtons}
				value={props.selected}
				classes={{
					root: cn(theme.tab, props.rootTabsClassName, { [theme.tab_rounded]: props.style === 'rounded' }),
					indicator: cn(theme.tab__indicator, props.indicatorClassName),
					flexContainer: cn(props.flexContainerClassName, {
						[theme.tabs__container_center]: props.tabsAlign === 'center',
						[theme.tabs__container_right]: props.tabsAlign === 'right'
					}),
					scroller: theme.scroller
				}}
				variant={props.variant}
				onChange={(e, value) => props.onChange(value)}
			>
				{props.tabs.map(tab => (
					<Tab
						disabled={tab.disabled}
						disableRipple={props.style !== 'rounded'}
						value={tab.value}
						key={tab.value}
						classes={{
							root: cn(theme.tab, props.tabClassName, { [theme.tab_rounded]: props.style === 'rounded' }),
							selected: cn(theme.tab_selected, props.selectedTabClassName)
						}}
						label={
							<div className={theme.tab__content}>
								<div title={tab.header} className={cn(theme.route, props.tabHeaderClassName)}>
									{tab.header}
								</div>
								{props.style !== 'rounded' && !!tab.label && (
									<div className={cn(theme.desc, props.tabLabelClassName)}>
										<span className={theme.seats__count}>{tab.label}</span>
									</div>
								)}
							</div>
						}
					/>
				))}
			</MUITabs>
		</div>
	);
};

export default Tabs;
